/* eslint-disable react/prop-types */
import React from "react";
import tw, { css, theme } from "twin.macro";

import Grid from "~components/styles/Grid.jsx";
import * as T from "~components/styles/Typography.jsx";
import Button from "~components/Button.jsx";
import Go from "~components/Go.jsx";
import Image from "~components/Image.jsx";
import PortableText from "~components/PortableText.jsx";

import blankImage from "~assets/images/image-full.jpg";

const ImageArticleSection = ({ data, onClick = () => {}, clickEvents }) => {
  const { backgroundColor, textColor, _rawBody, header, image, imageAlign } =
    data;

  //

  return (
    <section
      css={[
        css`
          background-color: ${backgroundColor?.hex || `white`};
          color: ${textColor?.hex || `black`};
        `,
        tw`relative`
      ]}
    >
      <Grid>
        <figure
          css={[
            css`
              width: 100%;

              @media screen and (min-width: ${theme`screens.md.min`}) {
                order: ${imageAlign === `left` ? `0` : `1`};
              }

              @media screen and (min-width: ${theme`screens.lg.min`}) {
                width: 50vw;

                ${imageAlign === `left` &&
                `transform: translate(calc(720px - 50vw));`}
              }
            `,
            tw`col-span-12 xl:max-h-[614px]`
          ]}
        >
          {image ? (
            <Image
              _css={[
                css`
                  width: calc(100% + 2rem);
                  max-width: none;
                  margin-left: -1rem;

                  @media screen and (min-width: 1025px) {
                    width: 100%;
                    margin-left: auto;
                  }
                `,
                tw`relative block h-full`
              ]}
              image={image}
            />
          ) : (
            <img
              src={blankImage}
              css={tw`w-full h-full object-cover`}
              alt="blank"
            />
          )}
        </figure>

        <article
          css={[
            css`
              @media screen and (min-width: 1025px) {
                order: ${imageAlign === `left` ? `1` : `0`};
              }
            `,
            tw`col-span-12 relative pt-10 pb-16 md:p-12`
          ]}
        >
          <div>
            <T.Head font="4">{header}</T.Head>
            <PortableText blocks={_rawBody} _css={[tw`w-full relative mt-8`]} />
          </div>

          {clickEvents?.[0] && (
            <div css={[tw`relative mt-12 flex flex-wrap`]}>
              {clickEvents.map(({ buttonTarget, buttonText }) => (
                <>
                  {buttonTarget ? (
                    <Go to={buttonTarget} _css={[tw`mr-4 mb-4`]}>
                      <Button color="white" text={buttonText} transparent />
                    </Go>
                  ) : (
                    <Button
                      _css={[tw`mr-4 mb-4`]}
                      color="white"
                      onClick={onClick}
                      text={buttonText}
                      transparent
                    />
                  )}
                </>
              ))}
            </div>
          )}
        </article>
      </Grid>
    </section>
  );
};

export default ImageArticleSection;
